const styles = {
  keyStyle: {
    width: "35%",
    // color: "#5E5E5E",
    fontSize: "13px",
    fontWeight: 500,
    textTransform: "uppercase",
    color: "#454545",
    fontFeatureSettings: "'clig' off, 'liga' off",
    // fontFamily: "Noto Sans",
    // fontSize: "16px",
    fontStyle: "normal",
    // fontWeight: "500",
    // lineHeight: "20px",
  },
  valueStyle: {
    width: "65%",
    // color: "#183053",
    fontSize: "13px",
    color: "#484848",
    // fontFamily: "Noto Sans",
    // fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "125%",
  },
  paiarStyles: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    paddingTop: "7px",
    gap: "5px",
    paddingBottom: "7px",
    paddingLeft: "15px",
  },
  paiarStyles2: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    paddingTop: "7px",
    gap: "5px",
    paddingBottom: "7px",
    paddingLeft: "15px",
    backgroundColor: "#EDEDED",
  },
  paiarStyles3: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    // paddingTop: "7px",
    // gap: "5px",
    // paddingBottom: "7px",
    paddingLeft: "15px",
  },
  paiarStyles4: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    // paddingTop: "7px",
    // gap: "5px",
    // paddingBottom: "7px",
    paddingLeft: "15px",
    backgroundColor: "#EDEDED",
  },
};

export default styles;
